import { render } from "./PageGerarLaudo.vue?vue&type=template&id=5a76bb24&scoped=true"
import script from "./PageGerarLaudo.vue?vue&type=script&lang=js"
export * from "./PageGerarLaudo.vue?vue&type=script&lang=js"

import "./PageGerarLaudo.vue?vue&type=style&index=0&id=5a76bb24&scoped=true&lang=css"
/* custom blocks */
import block0 from "./PageGerarLaudo.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a76bb24"]])

export default __exports__